import { apiFetch } from "../../../Utils/ApiClient";

export const selectedCoverPlanLife = (data) => {
    
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/leads`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in getAffrodablePlans:', error);
      throw error;
    }
  };
};

export const updateLeadsLife = (data) => {
    
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/leads`, {
        method: 'PUT',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in getAffrodablePlans:', error);
      throw error;
    }
  };
};